import React from 'react'
import { Drawer } from 'antd'
import { useDispatch } from 'react-redux'
import { conceptualLabelActions } from '../../../../../store/slices/conceptual-label.slice'
import useConceptualLabel from '../../../../../hooks/useConceptualLabel'
import EditConceptualLabelTabs from './EditConceptualLabelTabs'

const EditConceptualLabelDrawer = () => {
    const dispatch = useDispatch()
    const { canEdit, conceptualLabel } = useConceptualLabel()

    const handleClose = () => dispatch(conceptualLabelActions.setEditingConceptualLabelId(null))

    return (
        <Drawer 
            title={canEdit ? 'Edit Conceptual Label' : 'View Conceptual Label'} 
            autoFocus 
            onClose={handleClose} 
            open 
            width={560} 
            destroyOnClose
            zIndex={10000}
        >
            <EditConceptualLabelTabs 
                canEdit={canEdit}
                conceptualLabel={conceptualLabel}
                onSuccess={handleClose}
            />
        </Drawer>
    )
}

export default EditConceptualLabelDrawer
